import * as React from "react";
import {useContext, useEffect, useState} from "react";
import AppContent from "../Surfaces/AppContent";
import AuthContext from "../Services/AuthContext";
import AddUserVentureRestriction from "../Panel/User/AddUserVentureRestriction";
import AddUserDocumentRestriction from "../Panel/User/AddUserDocumentRestriction";
import UserRole from "../Lists/UserRole";
import UserVentureRestriction from "../Lists/UserVentureRestriction";
import UserDocumentRestriction from "../Lists/UserDocumentRestriction";
import AddUserRole from "../Panel/User/AddUserRole";
import {useOutletContext, useParams} from "react-router-dom";

function UserDetails(props) {
    const [auth] = useContext(AuthContext);
    const [user, setUser] = useState([]);
    const [roles, setRoles] = useState([]);
    const [ventureRestrictions, setVentureRestrictions] = useState([]);
    const [documentRestrictions, setDocumentRestrictions] = useState([]);
    const [refresh, setRefresh] = useState(0);
    const params = useParams();
    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch(`/api/user/${params.id}`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + auth.token
                }
            }).then(res => res.json())
                .then(data => {
                    setUser(data.user);
                    setDocumentRestrictions(data.document);
                    setVentureRestrictions(data.venture);
                    setRoles(data.role);
                })
                .catch(err => {
                    console.log(err)
                })
        }

        fetchData();
        return () => abortController.abort();
    }, [refresh, user.token]);
    const [addUserVentureRestriction, setAddUserVentureRestriction] = useState(false);
    const [addUserDocumentRestriction, setAddUserDocumentRestriction] = useState(false);
    const [addUserRole, setAddUserRole] = useState(false);
    const actions = useOutletContext();
    useEffect(() => {
        actions([
            {
                key: 'addUserRole',
                text: 'Dodaj Rolę',
                iconProps: {iconName: 'Add'},
                onClick: () => setAddUserRole(params.id)
            },
            {
                key: 'addUserVentureRestriction',
                text: 'Dodaj Ograniczenie Kontraktu',
                iconProps: {iconName: 'Add'},
                onClick: () => setAddUserVentureRestriction(params.id)
            },
            {
                key: 'addUserDocumentRestriction',
                text: 'Dodaj Ograniczenie Dokumentu',
                iconProps: {iconName: 'Add'},
                onClick: () => setAddUserDocumentRestriction(params.id)
            },
        ]);
        return actions;
    }, []);

    return (
        <AppContent title={`${user.name} ${user.surname}`} subtitle={user.email} backTo={'/user'}>
            <UserRole data={roles} refresh={() => setRefresh(refresh + 1)}/>
            <UserVentureRestriction data={ventureRestrictions} refresh={() => setRefresh(refresh + 1)}/>
            <UserDocumentRestriction data={documentRestrictions} refresh={() => setRefresh(refresh + 1)}/>
            <AddUserRole add={addUserRole} onSuccess={() => setRefresh(refresh + 1)}
                         dismissPanel={() => setAddUserRole(false)}/>
            <AddUserVentureRestriction add={addUserVentureRestriction} onSuccess={() => setRefresh(refresh + 1)}
                                       dismissPanel={() => setAddUserVentureRestriction(false)}/>
            <AddUserDocumentRestriction add={addUserDocumentRestriction} onSuccess={() => setRefresh(refresh + 1)}
                                        dismissPanel={() => setAddUserDocumentRestriction(false)}/>
        </AppContent>
    );
}

export default UserDetails;